import { createFileRoute } from '@tanstack/react-router'
import { assistantSearchSchema } from '../../../src/schemas/routeSchemas'

export const Route = createFileRoute('/assistant/case-search')({
  validateSearch: (search) => assistantSearchSchema.parse(search),
  loaderDeps: () => ({}),
})
